import { battleTypeList } from '@typings/common/rspType';

export function randomSelection() {
  const randomIndex = Math.floor(Math.random() * battleTypeList.length);
  return battleTypeList[randomIndex].key;
}
